var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0.5H0.5V34.5H34.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0166 3.60834C15.3293 3.25916 15.712 2.97985 16.1399 2.78862C16.5678 2.59739 17.0313 2.49855 17.4999 2.49855C17.9686 2.49855 18.4321 2.59739 18.86 2.78862C19.2879 2.97985 19.6706 3.25916 19.9833 3.60834L21.1499 4.91167C21.4834 5.28416 21.8963 5.57688 22.3582 5.76816C22.8201 5.95944 23.3191 6.04437 23.8183 6.01667L25.5683 5.92C26.0363 5.8942 26.5046 5.96742 26.9425 6.13487C27.3803 6.30233 27.7779 6.56026 28.1093 6.89182C28.4407 7.22338 28.6985 7.62111 28.8657 8.05905C29.033 8.49698 29.106 8.96527 29.0799 9.43334L28.9833 11.1817C28.9558 11.6806 29.0409 12.1792 29.2322 12.6408C29.4234 13.1024 29.716 13.5151 30.0883 13.8483L31.3916 15.015C31.7411 15.3277 32.0206 15.7105 32.212 16.1386C32.4034 16.5666 32.5023 17.0303 32.5023 17.4992C32.5023 17.9681 32.4034 18.4317 32.212 18.8598C32.0206 19.2878 31.7411 19.6707 31.3916 19.9833L30.0883 21.15C29.7158 21.4834 29.4231 21.8964 29.2318 22.3583C29.0405 22.8202 28.9556 23.3192 28.9833 23.8183L29.0799 25.5683C29.1057 26.0364 29.0325 26.5047 28.8651 26.9425C28.6976 27.3804 28.4397 27.778 28.1081 28.1094C27.7766 28.4408 27.3788 28.6985 26.9409 28.8658C26.503 29.033 26.0347 29.106 25.5666 29.08L23.8183 28.9833C23.3194 28.9559 22.8207 29.0409 22.3591 29.2322C21.8975 29.4235 21.4849 29.7161 21.1516 30.0883L19.9849 31.3917C19.6723 31.7411 19.2894 32.0207 18.8614 32.2121C18.4333 32.4035 17.9697 32.5024 17.5008 32.5024C17.0319 32.5024 16.5682 32.4035 16.1402 32.2121C15.7121 32.0207 15.3293 31.7411 15.0166 31.3917L13.8499 30.0883C13.5165 29.7158 13.1036 29.4231 12.6417 29.2318C12.1798 29.0406 11.6808 28.9556 11.1816 28.9833L9.43161 29.08C8.96353 29.1058 8.49528 29.0326 8.05742 28.8651C7.61957 28.6977 7.22196 28.4397 6.89055 28.1082C6.55915 27.7766 6.30141 27.3789 6.13416 26.941C5.96691 26.503 5.89392 26.0347 5.91994 25.5667L6.01661 23.8183C6.04406 23.3194 5.959 22.8208 5.76773 22.3592C5.57646 21.8976 5.28388 21.4849 4.91161 21.1517L3.60827 19.985C3.25883 19.6723 2.97927 19.2895 2.78788 18.8614C2.59649 18.4334 2.49756 17.9697 2.49756 17.5008C2.49756 17.0319 2.59649 16.5683 2.78788 16.1403C2.97927 15.7122 3.25883 15.3293 3.60827 15.0167L4.91161 13.85C5.2841 13.5166 5.57682 13.1036 5.7681 12.6417C5.95938 12.1798 6.04431 11.6808 6.01661 11.1817L5.91994 9.43167C5.89438 8.96373 5.96778 8.49566 6.13534 8.058C6.30291 7.62035 6.56088 7.22294 6.89241 6.89173C7.22394 6.56051 7.62159 6.30292 8.05941 6.13577C8.49722 5.96862 8.96536 5.89567 9.43327 5.92167L11.1816 6.01834C11.6805 6.04578 12.1792 5.96073 12.6408 5.76946C13.1023 5.57819 13.515 5.2856 13.8483 4.91334L15.0166 3.60834Z",
    stroke: "#EBB42C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3333H13.3499V13.35H13.3333V13.3333ZM21.6666 21.6667H21.6833V21.6833H21.6666V21.6667Z",
    stroke: "#EBB42C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.5L12.5 22.5",
    stroke: "#EBB42C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.8a0fd499bf87e7a93c44559256338226.svg";
export { ForwardRef as ReactComponent };